import writeXlsxFile from "write-excel-file";
import { fetchAttendeeReports } from "../../../../utils/services/portalBoticario";

const hasDate = (accomodation, date) =>
  accomodation.includes(`Ingresso_${date}`);

export async function createParticipantsXlsx(jwt, setFinishExport, idEvent) {
  const schema = [
    {
      column: "Nome",
      type: String,
      value: (data) => data.name,
    },
    {
      column: "E-mail",
      type: String,
      value: (data) => data.email,
    },
    {
      column: "Cargo",
      type: String,
      value: (data) => data.role,
    },
    {
      column: "Hospedagem",
      type: String,
      value: (data) => data.accomodation.split(";")[0],
    },
    {
      column: "Dia 08/04",
      type: String,
      value: (data) => (hasDate(data.accomodation, "0804") ? "Sim" : "Não"),
    },
    {
      column: "Dia 09/04",
      type: String,
      value: (data) => (hasDate(data.accomodation, "0904") ? "Sim" : "Não"),
    },
    {
      column: "Dia 10/04",
      type: String,
      value: (data) => (hasDate(data.accomodation, "1004") ? "Sim" : "Não"),
    },
    {
      column: "Departamento",
      type: String,
      value: (data) => data.code,
    },
    {
      column: "Inscrito por",
      type: String,
      value: (data) => `${data.creatorName} (${data.creatorEmail})`,
    },
  ];

  const data = await fetchAttendeeReports(jwt, idEvent);

  const progressBar = document.querySelector(".export-progress");
  const percentageBar = document.querySelector(".export-percentage");
  if (progressBar) progressBar.style.width = "100%";
  if (percentageBar) percentageBar.innerHTML = "100%";

  if (data && data.length > 0) {
    await writeXlsxFile(data, {
      schema,
      fileName: "participantes_boticario_cotas.xlsx",
    });
  }

  setTimeout(() => {
    setFinishExport(true);
  }, 1000);
}
